import {
  ProgressCircle,
  ProgressCircleBack,
  ProgressCircleProgress,
  ProgressText,
  ProgressWrapper,
  SIZE,
  STROKE_WIDTH,
} from '@/bundle/shared/components/CircleProgressBar/styles';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';

type ProgressBarCircleType = {
  count: number;
  totalCount: number;
};

const RADIUS = (SIZE - STROKE_WIDTH) / 2;
const CENTER = SIZE / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const CircleProgressBar = ({ count, totalCount }: ProgressBarCircleType) => {
  //calculate how many segments are filled
  const segmentsFilled = Math.min(count, totalCount);

  // Stroke length = (filled segments / total segments) * circumference
  const dashLength = (segmentsFilled / totalCount) * CIRCUMFERENCE;
  const dashArray = `${dashLength} ${CIRCUMFERENCE}`;

  const progressLabel = `${count}/${totalCount}`;

  return (
    <ProgressWrapper>
      <ProgressCircle>
        <ProgressCircleBack cx={CENTER} cy={CENTER} r={RADIUS} strokeWidth={STROKE_WIDTH} />
        <ProgressCircleProgress
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={dashArray}
        />
      </ProgressCircle>
      <ProgressText>
        <Typography variant='bodySmall' color={COLORS.grey[700]} fontWeight='medium'>
          {progressLabel}
        </Typography>
      </ProgressText>
    </ProgressWrapper>
  );
};
